<div class="sidebar px-3 py-2 py-md-3 border-end gradient">
    <div class="d-flex flex-column h-100">
        <div class="d-flex align-items-center mb-4 mt-2">
            <h4 class="sidebar-title mb-0 flex-grow-1 text-center">
                <img src="../../../assets/images/logoblanco.png" style="width: 100%;">
            </h4>

        </div>

        <!-- User Info -->
        <div class="sidebar-section sidebar-user clearfix sidebar-nav-mini-hide mt-4 logo-sidebar">
            <div *ngIf="(userInfo$ | async) as userInfo">
                <div class="user-info text-center">
                    <p>{{ userInfo.name }} {{ userInfo.given_name }}</p>
                    <div *ngIf="(selectedOrganization$ | async) as selectedEmpresa" class="mb-2">
                       <div *ngIf="selectedEmpresa != 'null' && selectedEmpresa != 'undefined'">
                           {{ selectedEmpresa }}
                       </div>
                    </div>
                    <a (click)="logout()" style="color: white!important; cursor: pointer; margin-top: 10px; margin-bottom: 20px" class="text-primary mb-5">
                        <i class="fa fa-sign-out"></i> Salir
                    </a>
                </div>
            </div>
        </div>

        <!-- Menu: main menu ul -->
        <div class="flex-grow-1 mt-5">

            <!-- Menu: grid view -->
            <ul class="menu-list grid d-flex flex-wrap border rounded mx-auto">
                <li>
                    <a class="m-link" href="index.html" routerLink="/landing-general" routerLinkActive="active">
                        <i class="fa fa-home"></i>
                        <span>Inicio</span>
                    </a>
                </li>
                <li>
                    <a class="m-link" routerLink="/onboarding" routerLinkActive="active">
                        <i class="fa fa-pencil-square-o"></i> 
                        <span>Registrar una empresa</span>
                    </a>
                </li>
                <!-- <li><a class="m-link" routerLink="/payment" routerLinkActive="active">
                    <i class="fa fa-shopping-cart"></i> <span>Comprar un reporte</span>
                </a>
                </li> -->
                <li>
                    <a class="m-link" [ngClass]="{'btn disabled no-border': !selectedEmpresa || selectedEmpresa == 'undefined' || selectedEmpresa=='null'}" routerLink="/actualizar-credenciales" routerLinkActive="active">
                        <i class="fa fa-key "></i>
                        <span>Actualizar credenciales</span>
                    </a>
                </li>
                <li>
                    <a class="m-link" [ngClass]="{'btn disabled': !selectedEmpresa || selectedEmpresa == 'undefined' || selectedEmpresa=='null'}" routerLink="/libro-compra-venta" routerLinkActive="active">
                        <i class="fa fa-book"></i> 
                        <span>Libro Compra Venta</span>
                    </a>
                </li>

                <!-- PARA REACTIVARLO PARA TODAS LAS EMPRESAS BORRAR ESTE Y DESCOMENTAR EL lI DE ABAJO -->
                <li *ngIf="selectedEmpresa == '77378155-9'">
                    <a class="m-link" routerLink="/cobranza-online" routerLinkActive="active">
                        <i class="fa fa-file-text"></i> 
                        <span>Cobranza Online</span>
                    </a>
                </li>

                <!-- <li *ngIf="selectedOrganization == '77378155-9'"></li>
                    <a class="m-link" [ngClass]="{'btn disabled': !selectedEmpresa || selectedEmpresa == 'undefined' || selectedEmpresa=='null'}" routerLink="/cobranza-online" routerLinkActive="active">
                        <i class="fa fa-file-text"></i> 
                        <span>Cobranza Online</span>
                    </a>
                </li> -->
                <!-- 
                <li><a class="m-link" href="#"><i class="fa fa-file-text-o"></i> <span>Solicitud de
                            Crédito</span></a></li>
                <li><a class="m-link" href="#"><i class="fa fa-file-text"></i> <span>Reporte
                            Consolidado</span></a></li>
                <li><a class="m-link" href="#"><i class="fa fa-file-o"></i> <span>Reporte Básico</span></a></li>
                <li><a class="m-link" href="#"><i class="fa fa-line-chart"></i> <span>Reporte
                            Financiero</span></a></li>
                <li><a class="m-link" href="#"><i class="fa fa-gavel"></i> <span>Informe Judicial</span></a>
                </li>
                <li><a class="m-link" href="#"><i class="fa fa-building"></i> <span>Empresa en un día</span></a>
                </li>
                <li><a class="m-link" href="#"><i class="fa fa-briefcase"></i> <span>Boletin
                            Concursal</span></a></li>
                <li><a class="m-link" href="#"><i class="fa fa-car"></i> <span>Deuda Sbif Leasing</span></a>
                </li>
                <li><a class="m-link" href="#"><i class="fa fa-car"></i> <span>Vehículos</span></a></li>
                <li><a class="m-link" href="#"><i class="fa fa-home"></i> <span>Bienes Raices</span></a></li>
                <li><a class="m-link" href="#"><i class="fa fa-money"></i> <span>Reporte Tesoreria</span></a>
                </li> 
                -->
            </ul>

        </div>

    </div>
</div>
